import Api from "../../config/api";
import useLoading from "../../hooks/useLoading";
import { showToast } from "../../lib/toast/ShowToast";
import { commonType } from "../../pages/main/lead";
import SpinLoader from "../../shared components/Loader/SpinLoader";

type propType = {
  label: string;
  id: any;
  setState: (val: commonType) => void;
  url?: string;
  apiCall?: (val: any) => void;
  setSelectedRecords?: (val: any) => void;
  params?: any;
};

const DeleteModalSingle: React.FC<propType> = (props) => {
  const {
    label,
    id,
    setState,
    url,
    apiCall,
    params,
    setSelectedRecords,
  } = props;
  const [loading, showLoader, hideLoader] = useLoading();

  const fn = {
    setCommonState: () => {
      setState({
        data: undefined,
        modal: false,
        check: "",
      });
      document.body.style.overflow = "unset";
    },
    deleteData: async () => {
      try {
        showLoader();
        const res = await Api(false).delete(`${url}/${id}`);
        if (res) {
          showToast(`${label} Deleted`, "success");
          apiCall?.(params);
          setSelectedRecords?.([]);
          fn.setCommonState();
          hideLoader();
        }
      } catch (error: any) {
        if (error.response.status >= 400 && error.response.status <= 499) {
          showToast(`${error.response.statusText}`, "error");
          hideLoader();
        } else {
          showToast(`${error.response.data.message}`, "error");
          hideLoader();
        }
      }
    },
  };

  return (
    <>
      <div className="delete_modal_wrapper">
        <div className="delete_modal_section">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="font14x500 textColor3 mb-0">{`Delete ${label}`}</h3>
            <img
              src="/Assets/Svg/closeIcon.svg"
              alt="close"
              style={{
                cursor: "pointer",
              }}
              onClick={fn.setCommonState}
            />
          </div>
          <div className="mt-2">
            <p className="mb-0 font10x400 textColor3">
              Are you sure you want to delete?{" "}
              <span className="font10x500 textColor3">Note: </span>The data you
              want to delete is not recoverable
            </p>
          </div>
          <div className="mt-4 d-flex gap-2 justify-content-end">
            <button
              className="btn font12x500 shadow-none modalBtnOutline"
              onClick={fn.setCommonState}
            >
              Cancel
            </button>
            <button
              className="btn font12x500 shadow-none modalBtnColor"
              style={{
                backgroundColor: "var(--error)",
              }}
              onClick={fn.deleteData}
            >
              {loading ? (
                <SpinLoader height="20" width="20" color="#fff" />
              ) : (
                "Delete"
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteModalSingle;
